// extracted by mini-css-extract-plugin
module.exports = {"position":"FloatingLineContact_position__CX_J0"};